export const GATE_VUE_RUNTIME_SCRIPT_SRC = "/vendor/vue-3.5.38.prod.js";

// The Gate runtime iframe is sandboxed without `allow-same-origin` (deliberate security
// boundary), which gives it an opaque origin. Opaque origins cannot read the browser's
// HTTP cache partition for the real page origin, so a `<script src>` fetched from inside
// the iframe can never benefit from caching, even when the exact same URL was already
// fetched by the host moments earlier. Since the file is small, the host fetches the
// source once (where caching works normally) and the text is embedded inline into each
// generated `srcDoc`, trading a per-iframe network round trip for a per-iframe parse/execute
// cost only.
export const GATE_VUE_RUNTIME_QUERY_KEY = ["gate-vue-runtime-source"];

export const fetchGateVueRuntimeSource = async (): Promise<string> => {
    const response = await fetch(GATE_VUE_RUNTIME_SCRIPT_SRC);

    if (!response.ok) {
        throw new Error(`Failed to load Gate Vue runtime asset: ${response.status}`);
    }

    return response.text();
};
